import Component from './Component';
import GlobalMessageComponent from './GlobalMessageComponent';
import ModalComponent from './ModalComponent';

export default class ModifyOrderComponent extends Component {
    get SELECTORS() {
        return {
            html: 'html',
            accountOrder: '.js-account-order',
            changeOrder: '.js-change-order',
            saveOrderCode: '.js-save-ordercode-header',
            popup: '.popup',
        }
    }

    get DATA() {
        return {
            order: 'data-ordercode',
            modal: 'data-modal',
            dataCSRFToken: 'data-csrftoken',
            id: 'data-id'
        }
    }

    get PARAMS() {
        return {
            openminicart: 'openminicart'
        }
    }

    constructor() {
        super();
        this.token = this.getDataAttribute(this.SELECTORS.html, this.DATA.dataCSRFToken);
        this.GlobalMessageComponent = new GlobalMessageComponent();
        this.ModalComponent = new ModalComponent();
    }

    saveOrderCodePopup(element, popupId) {
        const orderCode = element.closest(this.SELECTORS.accountOrder).getAttribute(this.DATA.id),
            popup = document.getElementById(popupId);
        popup.setAttribute(this.DATA.order, orderCode);
    }

    changeOrder(element) {
        const ctx = this;
        this.toggleLoader();
        const popup = element.closest(this.SELECTORS.popup),
            orderCode = popup.getAttribute(this.DATA.order);

        fetch(this.endpoints.ACCOUNT_GET_ORDER_ENTRIES.url + orderCode + '/modify', {
            method: 'post',
            headers: {
                'Content-Type': 'application/json', // This is set on request
                'X-Requested-With': 'XMLHttpRequest',
                'CSRFToken': this.token, // This is set on request
                'Cookie': this.token // This is missing from request
            }
        }).then((response) => response.json()).then((data) => {
            if (data.showPopUp) {
                this.toggleLoader();
                this.ModalComponent.closeModal();
                this.ModalComponent.openModal(document.getElementById('sessionTimeoutPopup'));
            } else {
                this.toggleLoader();
                location.href = '/?' + this.PARAMS.openminicart + '=true';
            }
        }).catch(function(error) {
                ctx.toggleLoader();
                ctx.ModalComponent.closeModal();
                
                ctx.GlobalMessageComponent.renderGlobalMessages('L\'ordine non può essere modificato. Contatta il Servizio Clienti al 800.23.66.38 per annullare l\'ordine in corso.', 'danger')
        });
    }

    bindEvents() {    
        this.events.on('click', this.SELECTORS.saveOrderCode, (e) => {
            const element = e.target.matches(this.SELECTORS.saveOrderCode) ? e.target : e.target.closest(this.SELECTORS.saveOrderCode);
            this.saveOrderCodePopup(e.target, element.getAttribute(this.DATA.modal));
        });

        this.events.on('click', this.SELECTORS.changeOrder, (e) => {
            this.changeOrder(e.target);
        });
    }

    render() {
        this.log('render Modify Order');
        this.bindEvents();
    }
}